import { APIFetchStudioActivityLogs, RequestHeaders } from "@certa/network";
import type { HashMap } from "@certa/types";
import { studioCentralTemplatesModelCreator } from "../models/studio.models";
import type { PaginatedResultsResponse } from "../types/generic.types";
import type { TemplateStatusTypes } from "../types/studio.types";
import type {
  ExternalProcessResponse,
  ExternalUpsertWorkflow
} from "../types/workflow.types";

export async function getCentralizedStudioTemplates(
  page: number = 1,
  templateState?: TemplateStatusTypes
) {
  const requestOptions: RequestInit = {
    method: "POST",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: JSON.stringify({
      page,
      templateState
    })
  };

  const response = await APIFetchStudioActivityLogs<
    PaginatedResultsResponse<ExternalProcessResponse>
  >(`ext/studio-templates`, requestOptions);

  return studioCentralTemplatesModelCreator(response);
}

export function getCentralizedStudioTemplateJSON(workflowUID: string) {
  const requestOptions: RequestInit = {
    method: "POST",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: JSON.stringify({
      workflowUID
    })
  };

  return APIFetchStudioActivityLogs<
    PaginatedResultsResponse<
      { id: number; answer: string; tag: string } & HashMap
    >
  >(`ext/studio-template-json`, requestOptions).then(response => response);
}

export function upsertWorkflow(reqBody: ExternalUpsertWorkflow) {
  const requestOptions: RequestInit = {
    method: "POST",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: JSON.stringify({
      reqBody,
      tenant: "support"
    })
  };

  return APIFetchStudioActivityLogs<{ id: number; uid: string }>(
    `ext/upsert-workflow`,
    requestOptions
  ).then(response => response);
}
